import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeDrugIngredient } from "../Entity/TreeNodeDrugIngredient";
import { DrugIngredient } from "../../../Data/Art57Data/DrugIngredient";
import { ErrorType } from "../../ErrorType";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeDrugIngredientsList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Drug Ingredients ({param})');
      this.parent = parent;
      this.labelNodeName = 'Drug Ingredients';
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
      if (this.parent) {
        (this.parent as Art57Node).refreshLabel();
      }
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      let node = new TreeNodeDrugIngredient(this.ioc!, this);
      if (params && params.roleofingredient) {
        node.data.model = { ...node.data.model, roleofingredient: params.roleofingredient } ;
      } 
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeDrugIngredientsList =
        new TreeNodeDrugIngredientsList(this.ioc!, newParent);
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  
    override validateBusinessRules(): any[] {
      let errors: any = [];
      if (!this.children || this.children.length == 0) {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.bussinessValidationError,
          controlId: undefined,
          controlLabel: '',
          error: 'Section is Mandatory',
        });
      } else if (this.children && this.children.length > 0) {
        let activeIngredientFound = false;
  
        for (let i = 0; i < this.children!.length; i++) {
          let childAttachment = this.children![i];
          if (childAttachment.data.model.roleofingredient == 1) {
            activeIngredientFound = true;
            break;
          }
        }
  
        if (!activeIngredientFound) {
          errors.push({
            node: this,
            errorID: this.key,
            errorType: ErrorType.bussinessValidationError,
            controlId: undefined,
            controlLabel: '',
            error: 'Active Ingredient is required',
          });
        } else {
          errors.push({
            node: this,
            errorID: this.key,
            errorType: ErrorType.errorInactive,
            controlId: undefined,
            controlLabel: '',
            error: '',
          });
        }
  
      }
  
      return errors;
    }
  
    override getMessage(): any {
      let message = {};
      let activeingredients: any[] = [];
      let adjuvants: any[] = [];
      let excipients: any[] = [];
  
      this.children?.forEach((node) => {
        let art57Node = node as Art57Node;
        let art57Message = art57Node.getMessage();
        if (
          art57Message != null &&
          node.data instanceof DrugIngredient &&
          node.data.model
        ) {
          let currentNode = node as TreeNodeDrugIngredient;
          if (currentNode.data.model.roleofingredient == 1) {
            activeingredients.push(art57Message);
          } else if (currentNode.data.model.roleofingredient == 2) {
            excipients.push(art57Message);
          } else if (currentNode.data.model.roleofingredient == 3) {
            adjuvants.push(art57Message);
          }
        }
      });
  
      let activeingredientsMessage = null;
      if (activeingredients.length > 0) {
        activeingredientsMessage = {
          activeingredients: { activeingredient: activeingredients },
        };
        message = { ...message, ...activeingredientsMessage };
      }
  
      let adjuvantsMessage = null;
      if (adjuvants.length > 0) {
        adjuvantsMessage = { adjuvants: { adjuvant: adjuvants } };
        message = { ...message, ...adjuvantsMessage };
      }
  
      let excipientsMessage = null;
      if (excipients.length > 0) {
        excipientsMessage = { excipients: { excipient: excipients } };
        message = { ...message, ...excipientsMessage };
      }
  
      return { ...message };
    }
  
    override getHeaders(): string[] {
      return ['EV Code', 'Substance', 'Role of Ingredient', 'Amount Value Type',  
              'Numerator Value (Low Limit)', 'Numerator Prefix (Low Limit)', 'Numerator Unit (Low Limit)', 
              'Denominator Value (Low Limit)', 'Denominator Prefix (Low Limit)', 'Denominator Unit (Low Limit)', 
              'Numerator Value (High Limit)', 'Numerator Prefix (High Limit)', 'Numerator Unit (High Limit)', 
              'Denominator Value (High Limit)', 'Denominator Prefix (High Limit)', 'Denominator Unit (High Limit)'
             ];
    }
  }

